module.exports = __webpack_public_path__ + "fonts/Roboto-MediumItalic.28e50516.woff";